<template>
  <Modal :show="Boolean(value)" @close="close" class="shop-modal" clickaway>
    <Card theme="flat">
      <template #default>
        <ProductDetails
          :value="value"
          v-bind="$attrs"
          :features="features"
          @open:modal="$ev => $emit('input', $ev)"
          @select="(...args) => $emit('select', ...args)"
        />
      </template>
      <template #footer>
        <ButtonComponent :label="$t('close')" @click="close" class="shop-modal__close" />
        <template v-if="actions && actions.length">
          <component
            v-for="{ listeners, component, ...props } in actions"
            :is="component || 'ButtonComponent'"
            v-bind="props"
            v-on="listeners"
          />
        </template>
      </template>
    </Card>
  </Modal>
</template>

<script>
import { ModalComponent as Modal } from 'vue-elder-modal'
import ProductDetails from './Details'
import Card from '@kvass/card'

export default {
  inject: ['bus'],
  data() {
    return {
      type: null,
      value: null,
      actions: null,
    }
  },
  computed: {
    features() {
      switch (this.type) {
        case 'bundle':
          return []
        case 'set':
          return ['bundle', 'property-changes']
      }
    },
  },
  methods: {
    close() {
      this.type = null
      this.value = null
      this.actions = null
    },
  },
  mounted() {
    this.bus.$on('product', ({ type, data, actions }) => {
      this.type = type
      this.value = data
      this.actions = actions
    })
    this.bus.$on('product:close', () => this.close())
  },
  components: {
    Modal,
    ProductDetails,
    Card,
  },
}
</script>

<style lang="scss">
@import '../mixins';

.shop-modal {
  z-index: 1001;
  padding: calc(var(--shop-spacing) * 2);

  @include onPhone {
    padding: 0;
  }

  & > .kvass-card {
    height: 100%;
    width: 100%;
    overflow-y: auto;

    @include onPhone {
      border-radius: 0;
      max-height: 100dvh;

      & > .kvass-card__footer {
        font-size: 0.8em;
      }
    }

    & > .kvass-card__content {
      display: flex;
      padding: var(--shop-spacing);
    }

    & > .kvass-card__footer {
      padding-inline: var(--shop-spacing);
      padding-block: calc(var(--shop-spacing) / 2);
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;

      position: sticky;
      bottom: 0;
      z-index: 1000;

      border-top: 1px solid var(--border-color);
    }
  }

  &__close {
    margin-right: auto;
  }

  .shop-product-details {
    flex-grow: 1;
    padding: 0 !important;

    &-inner {
      max-height: initial;
    }
  }

  .shop-product-details__images {
    align-self: stretch;
  }
}
</style>
